import classes from './chat.module.css';

const ChatEmptyState = () => {
  return (
    <div className={classes.emptyStateContainer}>
      <div>Start a conversation!</div>
    </div>
  );
};

export default ChatEmptyState;
